module.exports = __webpack_public_path__ + "static/assets/51b6bffe553abf33ea1939808f41ba05.gif";